import { AUTH, LOGOUT } from '../constants/actionTypes.js';

const authReducer = (state = { authData: [] }, action) => {
    switch (action.type) {
        case AUTH:
            const { roleType, username, email, gender, dateOfBirth, ethnicity, community, _id } = action?.data?.result;
            const token = action?.data?.token;
            localStorage.setItem('profile', JSON.stringify({ id: _id, roleType, token, username, email, gender, dateOfBirth, ethnicity, community }));
            return { ...state, authData: action?.data.token };
        case LOGOUT:
            localStorage.clear();
            sessionStorage.clear();
            window.location.reload();
            return { ...state, authData: null };
        default:
            return state;
    }
};

export default authReducer;